/* eslint-disable camelcase */
export default {
  show_as_grid: 'Show as Grid',
};
